import type { StatColumn } from './statsTableDefs';
import type { PointsTimeFilter } from '@/lib/timeFilter';

export type ScoringMode = 'sabotage' | 'normal';
export type PositionType = 'batter' | 'pitcher';

export const getSPTSLabel = (scoringMode: ScoringMode): 'SPTS' | 'PTS' =>
  scoringMode === 'sabotage' ? 'SPTS' : 'PTS';

export function getStatColumns(
  scoringMode: ScoringMode,
  positionType: PositionType,
  timeFilter: PointsTimeFilter,
): StatColumn[] {
  if (scoringMode === 'normal') return [];

  if (positionType === 'pitcher') {
    const trailing: StatColumn =
      timeFilter === 'season'
        ? {
            key: 'WL',
            label: 'W-L',
            getValue: (s) => `${s?.pitcher_wins ?? 0}-${s?.pitcher_losses ?? 0}`,
            isRate: true,
          }
        : {
            key: 'BS',
            label: 'BS',
            getValue: (s) => s?.blown_saves ?? 0,
          };
    return [
      { key: 'K',  label: 'K',  getValue: (s) => s?.pitcher_strikeouts ?? 0 },
      { key: 'BB', label: 'BB', getValue: (s) => s?.walks_allowed ?? 0 },
      { key: 'ER', label: 'ER', getValue: (s) => s?.earned_runs ?? 0 },
      { key: 'HR', label: 'HR', getValue: (s) => s?.home_runs_allowed ?? 0 },
      trailing,
    ];
  }

  return [
    { key: 'K',    label: 'K',    getValue: (s) => s?.strikeouts ?? 0 },
    { key: 'OUT',  label: 'OUTS', getValue: (s) => (s ? s.at_bats - s.hits : 0) },
    { key: 'GIDP', label: 'GIDP', getValue: (s) => s?.gidp ?? 0 },
    { key: 'E',    label: 'E',    getValue: (s) => s?.errors ?? 0 },
    {
      key: 'AVG',
      label: 'AVG',
      getValue: (s) =>
        s && s.at_bats > 0
          ? (s.hits / s.at_bats).toFixed(3).replace(/^0/, '')
          : '-',
      isRate: true,
    },
  ];
}
